import styles from "./CardEvent.module.scss";
import Image from "@components/Image";
import Button from "@components/Button";
import Link from "@components/Link";
import cx from "classnames";
import gstyles from "@gstyles/index";
import { useRouteContext } from "@providers/RouteProvider";
import Markdown from "@components/Markdown";
const View = ({
  image = {},
  title = "",
  description = "",
  phone = "",
  reminderText = "",
  website = "",
  className,
  style,
}: any) => {
  const { router } = useRouteContext();
  return (
    <div className={cx(styles.card, className)} style={style}>
      <div className={styles.img}>
        <Image
          {...image}
          alt={image?.alt || title || "Event image"}
          loading="eager"
          scale="1.15"
          wrapperProps={{ className: cx(styles.img) }}
          layout="fill"
          objectFit="cover"
        />
      </div>
      <div className={styles.box}>
        {!!title && (
          <div className={cx("ama-content", styles.title)}>{title}</div>
        )}
        <div className={styles.descBox}>
          <div className={cx("ama-content", styles.description)}>
            <Markdown content={description} />
          </div>
          {/* <div
            className={cx("ama-content", styles.description)}
            dangerouslySetInnerHTML={{
              __html: description,
            }}
          ></div> */}
          <div className={styles.groupInfo}>
            <Button
              onClick={() => {
                router.open(website);
              }}
              type="icon"
              className={cx("uppercase button", styles.button)}
              label="website"
              suffix="shape-arrow"
            />

            <div className={styles.footer}>
              <span>{reminderText}</span>
              <div className={styles.group}>
                {gstyles.icons({ name: "phone-yellow", size: 24 })}
                <Link href={`tel:${phone}`} label={phone} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default View;
